export default {
  CONTAINER: {
    MOUNTED: 'CONTAINER.MOUNTED',
    CHANGESTATE: 'CONTAINER.CHANGESTATE',
    ERROR: 'CONTAINER.ERROR',
  },
  DEALERS: {
    DEALER_FETCHED: 'DEALERS.DEALER_FETCHED',
    CHANGE: 'DEALERS.CHANGE',
    CHANGED: 'DEALERS.CHANGED',
    SELECT: 'DEALERS.SELECT',
    SET_PREFERRED: 'DEALERS.SET_PREFERRED',
    UNSET_PREFERRED: 'DEALERS.UNSET_PREFERRED',
    CHECK_PREFERRED: 'DEALERS.CHECK_PREFERRED',
    PREFERRED_CHECKED: 'DEALERS.PREFERRED_CHECKED',
    UPDATE: 'DEALERS.UPDATE',
    UPDATE_DEALER_CARD: 'DEALERS.UPDATE_DEALER_CARD',
  },
  FORM: {
    ADDRESS_AUTOCOMPLETED: 'FORM.ADDRESS_AUTOCOMPLETED',
    REQUIRED_FIELD: 'FORM.REQUIRED_FIELD',
    SHOW_GLOBAL_ERROR: 'FORM.SHOW_GLOBAL_ERROR',
  },
  VEHICLE: {
    UPDATED: 'VEHICLE.UPDATED',
    UPDATE: 'VEHICLE.UPDATE',
    RESET: 'VEHICLE.RESET',
    SELECTED: 'VEHICLE.SELECTED',
    DESELECTED: 'VEHICLE.DESELECTED',
    TAXONOMYUPDATED: 'VEHICLE.TAXONOMYUPDATED',
    BACK_TO_MODELS: 'VEHICLE.BACK_TO_MODELS',
    STATE_UPDATED: 'VEHICLE.STATE_UPDATED',
  },
  DISCLAIMERS: {
    OPEN: 'DISCLAIMERS.OPEN',
  },
  STEPS: {
    VEHICLE_UPDATED: 'VEHICLE.UPDATED',
    DEALER_UPDATED: 'DEALER.UPDATED',
  },
};
